export default "__VITE_ASSET__QiYKfKms__"